import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-assinatura-documento',
  templateUrl: './assinatura-documento.component.html',
  styleUrls: ['./assinatura-documento.component.scss'],
})
export class AssinaturaDocumentoComponent {
  @Input() nomeTitular: string = '';
  @Input() dataAssinatura: string = '';
  @Input() horaAssinatura: any = '';
  @Input() nomeCorretora: string = '';
  @Input() nomeVendedor: string = '';
  @Input() ehTitular: boolean = true;
  @Input() ehDocFinal: boolean = true;

  constructor() {}
}
